import { useEffect, useMemo, useState } from "react";
import _ from "underscore";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";

export const useGlobalFields = ({ filterValues, setFilterValues }) => {

    const [createField, setCreateField] = useState({ search: "", status: "active" })
    const [loader, setLoader] = useState(false);
    const [rowData, setRowData] = useState([]);
    const status = [
        {
            label: "Active",
            value: "active"
        },
        {
            label: "Deleted",
            value: "deleted"
        }
    ]
    const columns = [
        {
            key: "custom_field_name",
            label: "Field Name",
            style: { width: "15%" },
            render: (row) => <div className="fw-bold d-flex gap-2">
                {/* <span className="text-secondary" style={{ fontSize: "9px", backgroundColor: "#e2e8f0", padding: "2px 5px" }}>LOCKED</span> */}
                <span className="text-truncate w85" title={row?.custom_field_name}>{row?.custom_field_name}</span>
            </div>
        },
        {
            key: "field_type",
            label: "Field Type",
            style: { width: "10%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="text-truncate text-secondary" title={row?.field_type}>{row?.field_type}</div>
        },
        {
            key: "description",
            label: "Description",
            style: { width: "15%" },
            render: (row) => <div className="text-truncate">{row?.description}</div>
        },
        {
            key: "context_name",
            label: "Context",
            style: { width: "15%" },
            render: (row) => <div className="text-truncate fw-semibold" title={row?.context_name}>{row?.context_name}</div>
        },
        {
            key: "screen_name",
            label: "Screen",
            style: { width: "10%" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div className="text-primary fw-semibold d-flex justify-content-center">
                <div className="px-2 rounded-pill" >{row?.screen_name}</div>
            </div>
        },
        {
            key: "project_name",
            label: "Projects",
            style: { width: "15%" },
        },
        {
            key: "options",
            label: "Options",
            style: { width: "10%" },
        },
        {
            key: "field_id",
            label: "Field ID",
            style: { width: "10%" },
        },
        // {
        //     key: "action",
        //     label: "Action",
        //     style: { width: "6%" },
        //     headerStyle: { textAlign: "center" },
        // },
    ]

    useEffect(() => {
        filterValues?.apiCall && getFields();
    }, [filterValues?.apiCall])

    const getFields = async () => {
        try {
            setLoader(true);
            const res = await services.getInvokeRemote("GET", Urls("GETGLOBALFIELDS"), {});
            if (res?.body?.error_status === false) {
                const data = _.uniq(res?.body?.data?.screen_schemes_data, "custom_field_id")?.sort((a, b) => a?.custom_field_name?.localeCompare(b?.custom_field_name));
                setRowData(data);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader(false);
            setFilterValues((prev) => ({ ...prev, apiCall: false }));
        }
    }

    const filteredData = useMemo(() => {
        if (!createField?.search?.trim()) return rowData;
        return rowData?.filter((item) => item?.custom_field_name?.toLowerCase()?.includes(createField?.search.toLowerCase()));
    }, [rowData, createField?.search]);

    return { columns, rowData: filteredData, loader, createField, setCreateField, status }
}